import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

import { memoizedGetInvitePermissions } from '@confluence/onboarding-helpers/entry-points/getInvitePermissions.ts';
import { PERSISTENT_INVITE } from '@confluence/onboarding-helpers/entry-points/constants/onboarding-state-constants.ts';

const CONFLUENCE_KEY = 'confluence';

export const checkInviteCapabilities = async (
	cloudId: string,
	setOnboardingState: (args: any) => void,
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	source: string = 'persistentInviteButton',
) => {
	const response = await memoizedGetInvitePermissions(cloudId);
	const canInviteToConfluence: boolean = [
		...(response?.directInvite ?? []),
		...(response?.invitePendingApproval ?? []),
	].some((item) => item.includes(CONFLUENCE_KEY));

	void setOnboardingState({
		key: PERSISTENT_INVITE.HAS_INVITE_CAPABILITIES,
		value: canInviteToConfluence,
	});

	createAnalyticsEvent({
		type: 'sendTrackEvent',
		data: {
			action: 'called',
			actionSubject: 'inviteCapabilitiesAPI',
			attributes: {
				hasPermission: canInviteToConfluence,
			},
			source,
		},
	}).fire();

	return canInviteToConfluence;
};
